export const GET_SUBSCRIPTION = '[Subscription] Get subscription';
export const GET_SUBSCRIPTION_SUCCESS =
  '[Subscription] Get subscription Success';
export const GET_SUBSCRIPTION_ERROR = '[Subscription] Get subscription Error';

export const GET_LABEL_SUBSCRIPTION = '[Subscription] Get label subscription';
export const GET_LABEL_SUBSCRIPTION_SUCCESS =
  '[Subscription] Get label subscription Success';
export const GET_LABEL_SUBSCRIPTION_ERROR =
  '[Subscription] Get label subscription Error';

export const GET_INVOICES = '[Subscription] Get invoices';
export const GET_INVOICES_SUCCESS = '[Subscription] Get invoices Success';
export const GET_INVOICES_ERROR = '[Subscription] Get invoices Error';

export const CREATE_SUBSCRIPTION = '[Subscription] Create subscription';
export const CREATE_SUBSCRIPTION_SUCCESS =
  '[Subscription] Create subscription Success';

export const CREATE_MERCH_SUBSCRIPTION_SUCCESS =
  '[Subscription] Create Merch subscription Success';

export const CANCEL_MERCH_SUBSCRIPTION_SUCCESS =
  '[Subscription] Cancel Merch subscription Success';

export const CREATE_SUBSCRIPTION_ERROR =
  '[Subscription] Create subscription Error';

export const CANCEL_SUBSCRIPTION = '[Subscription] Cancel subscription';
export const CANCEL_SUBSCRIPTION_SUCCESS =
  '[Subscription] Cancel subscription Success';
export const CANCEL_SUBSCRIPTION_ERROR =
  '[Subscription] Cancel subscription Error';

export const CHECKOUT_INITIATED = '[Subscription] Checkout initiated';

export const CLEAR_SUBSCRIPTIONS = '[Subscription] Clear subscription';
